document.addEventListener("DOMContentLoaded", function () {
  const ZOOM_CLASS = "is-zooming";

  // アクティブスライドのズームアニメーションを scale(1) から開始させる
  function startZoom(slide) {
    if (!slide) return;
    // 一度クラスを外して reflow を挟むことでアニメーションを確実に頭から再生する
    slide.classList.remove(ZOOM_CLASS);
    void slide.offsetWidth;
    slide.classList.add(ZOOM_CLASS);
  }

  const pdgTopSwiper = new Swiper("#pdgTopSwiper", {
    loop: true,
    speed: 1000,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    on: {
      // 初期表示スライドのズームを開始
      afterInit(swiper) {
        startZoom(swiper.slides[swiper.activeIndex]);
      },
      // 切り替え開始時：新しいアクティブスライドのズームを開始する。
      // 出ていくスライドはここではクラスを外さず、ズームを継続させる。
      slideChangeTransitionStart(swiper) {
        startZoom(swiper.slides[swiper.activeIndex]);
      },
      // クロスフェード完了後：アクティブ以外のズームクラスを外す。
      // この時点で出ていくスライドは不可視なので、scale が戻っても見えない。
      slideChangeTransitionEnd(swiper) {
        const active = swiper.slides[swiper.activeIndex];
        swiper.slides.forEach(function (slide) {
          if (slide !== active) slide.classList.remove(ZOOM_CLASS);
        });
      },
    },
  });
});
